import Nav from "@/components/varna/Nav";
import AnnouncementBar from "@/components/varna/AnnouncementBar";
import Hero from "@/components/varna/Hero";
import CountdownSection from "@/components/varna/CountdownSection";
import IvoQuote from "@/components/varna/IvoQuote";
import Manifesto from "@/components/varna/Manifesto";
import Speakers from "@/components/varna/Speakers";
import Program from "@/components/varna/Program";
import SocialProof from "@/components/varna/SocialProof";
import Community from "@/components/varna/Community";
import Book from "@/components/varna/Book";
import Location from "@/components/varna/Location";
import Partnership from "@/components/varna/Partnership";
import Sponsors from "@/components/varna/Sponsors";
import Tickets from "@/components/varna/Tickets";
import Newsletter from "@/components/varna/Newsletter";
import Footer from "@/components/varna/Footer";
import VipPopup from "@/components/varna/VipPopup";

export default function VarnaLanding() {
  return (
    <main data-testid="varna-landing" className="relative">
      <AnnouncementBar />
      <Nav />
      <Hero />
      <Sponsors />
      <CountdownSection />
      <IvoQuote />
      <Manifesto />
      <Speakers />
      <Program />
      <SocialProof />
      <Community />
      <Book />
      <Location />
      <Partnership />
      <Tickets />
      <Newsletter />
      <Footer />
      <VipPopup />
    </main>
  );
}
